<template>
  <!-- 选择地址弹出层 -->
  <van-popup
    v-model="showPicker"
    round
    position="bottom"
  >
    <div class="popup-box">
      <div class="title-box">
        <div>{{ title }}</div>
        <van-icon
          name="clear"
          color="#E9E9E9"
          size="20"
          @click="close"
        />
      </div>
      <van-search
        v-model="searchKey"
        placeholder="请输入搜索"
        class="search-input"
        clearable
      />
      <div class="address-box">
        <div
          class="address-item"
          :class="{active: activeIndex === index}"
          v-for="(item, index) in filterList"
          :key="index"
          @click="select(index)"
        >
          <div class="item-left">
            <div>
              <div class="item-name">{{ item.productSkuName }}</div>
            </div>
          </div>
          <div
            class="item-icon"
            v-if="activeIndex === index"
          >
            <van-icon name="success" />
          </div>
        </div>
      </div>
      <van-row>
        <van-col
          span="22"
          offset="1"
        >
          <van-button
            type="info"
            block
            :disabled="activeIndex < 0"
            @click="confirm"
          >确定</van-button>
        </van-col>
      </van-row>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '选择'
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchKey: '',
      showPicker: false,
      activeIndex: -1
    };
  },
  computed: {
    filterList() {
      return this.searchKey ? this.list.filter(item => {
        return item.productSkuName.includes(this.searchKey) || item.productSkuName.includes(this.searchKey);
      }) : this.list;
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    open() {
      this.showPicker = true;
    },
    close() {
      this.showPicker = false;
      this.searchKey = '';
      this.activeIndex = -1;
    },
    confirm() {
      this.$emit('confirm', this.filterList[this.activeIndex]);
      this.close();
    },
    select(index) {
      this.activeIndex = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.popup-box{
  padding: 16px 8px 0;
}
.title-box{
  display: flex;
  justify-content: space-between;

  padding: 8px 12px;

  font-size: 16px;
}
.search-input{
  .van-search__content{
    border-radius: 8px;
    .van-cell{
      padding: 8px 8px 8px 0;
    }
  }
}
.address-box {
  overflow-y: auto;

  height: 45vh;
  .address-item{
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 12px;

    letter-spacing: -0.38px;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;

    &.active{
      color: #1989fa;
      .item-icon,
      .item-left,
      .item-name,
      .item-address,
      .item-distance{
        color: #1989fa;
      }
    }

    .item-icon{
      color: #B7BFC8;
    }

    .item-left{
      display: flex;
      align-items: center;

      margin-right: 12px;
    }

    .item-name{
      color: #3B3B3B;

      font-size: 15px;
      font-weight: 600;
    }
  }
}
.van-row{
  padding: 10px 0;
}
</style>
